import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendService } from 'src/app/shared/services/backend.services';
import { environment } from 'src/environments/environment';



@Injectable({
    providedIn: 'root'
})
export class ContactUsService {  
    public isContactUsShow = false;
    public baseURL = environment.apiUrl;

    constructor(private http: HttpClient, private backendService: BackendService) {}

    public getproductNamesList(): any {
        const url = `${this.baseURL}/ava/platform/contact-us/products/v1`;

        return this.http.get(url);
    }

    public getCategoriesList(): any {
        const url = `${this.baseURL}/ava/platform/contact-us/categories/v1`;

        return this.http.get(url);
    }

    public createContactUs(requestObj: any) {
        return this.backendService.postFormData('/ava/platform/contact-us/v1', requestObj);
    }
}
